// Wordpress automatically adds padding around left and right aligned images
// In these scenarios, the top padding causes images to not be top-aligned with the text to the side of it.
// The below logic detects such scenarios and removes the top padding so images look better.

/*jQuery( ".single-news-post-body div.wp-block-image" ).toArray().forEach(function(element) {
    const hasParagraphAbove = jQuery(element.previousElementSibling).is('p');
    
    if(hasParagraphAbove) {
        const imageFigure = jQuery(element).children("figure").first();
        
        if( imageFigure.hasClass("alignleft") || imageFigure.hasClass("alignright") ) {
            imageFigure.css('margin-top', '0')
        }
    }
});*/